module.exports = __webpack_public_path__ + "static/media/Residential_25.e5ba8807.jpg";